import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@material-ui/core';
import {
  noRiskComorbidity,
  moderateRiskDna,
  highRiskDna,
} from 'on_web/assets/imageList';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

/**
 * Component displaying the overall risk for the group.
 */
export default function TraitGroupsAssessmentCard(props) {
  const { t } = useTranslation();
  const { isDesktop } = props;

  const useStyles = makeStyles(theme => ({
    text: {
      fontSize: '18px',
      fontFamily: 'Museo',
      fontWeight: 'bold',
    },
    riskLevel: {
      fontSize: '25px',
      fontFamily: 'Museo',
      fontWeight: 'bold',
    },
  }));

  const classes = useStyles();
  return (
    <Box
      style={{
        paddingLeft: '20px',
        paddingRight: '20px',
        marginTop: '14px',
        paddingBottom: '22px',
      }}
    >
      {isDesktop && (
        <Box mb={2} mt={2}>
          <Typography variant="h5">{props.groupName.toUpperCase()}</Typography>
        </Box>
      )}
      <Grid
        container
        direction={props.isDesktop ? 'row' : 'column'}
        justify="center"
        alignItems="center"
      >
        <Grid item xs={isDesktop ? 3 : 12}>
          <Box justifyContent="center">
            <img
              alt="risk level illustration"
              src={
                props.riskLevel === 0
                  ? noRiskComorbidity
                  : props.riskLevel === 1
                  ? moderateRiskDna
                  : highRiskDna
              }
              width={107}
            />
          </Box>
        </Grid>

        <Grid item xs={isDesktop ? 5 : 12}>
          <Box className={classes.riskLevel}>{props.riskLabel}</Box>
        </Grid>

        {/*<Grid item xs={isDesktop ? 6 : 12}>
          <Box className={classes.text}>
            <Typography
              variant={'body1'}
              style={{
                textAlign: isDesktop ? 'left' : 'center',
                marginTop: isDesktop ? 0 : '15px',
              }}
            >
              {props.riskLevel === 2
                ? `You are genetically very likely to have ${
                    props.numberOfHighRiskTraits
                  } ${props.groupName} risk factor${
                    props.numberOfHighRiskTraits > 1 ? 's' : ''
                  } that can contribute to a severe COVID-19 infection.`
                : props.riskLevel === 1
                ? `You are genetically very likely to have ${
                    props.numberOfHighRiskTraits
                  } ${props.groupName} risk factor${
                    props.numberOfHighRiskTraits > 1 ? 's' : ''
                  } that can contribute to a moderate COVID-19 infection.`
                : `You don't have genetic ${props.groupName} risk factors that can contribute to a severe COVID-19 infection.`}
            </Typography>
          </Box>
                </Grid>*/}
      </Grid>
    </Box>
  );
}

TraitGroupsAssessmentCard.propTypes = {
  groupName: PropTypes.string.isRequired,

  riskLevel: PropTypes.number.isRequired,

  riskLabel: PropTypes.string.isRequired,

  numberOfHighRiskTraits: PropTypes.number.isRequired,

  numberOfModerateRiskTraits: PropTypes.number.isRequired,

  isDesktop: PropTypes.bool.isRequired,
};
